import constants from './constants.js';

var currentLocation = window['location'];
var currentOrigin = currentLocation['origin'];
var currentHost = currentLocation['host'];
var getCurrentApplicationHostInfo = function getCurrentApplicationHostInfo() {
  var rebrandState = currentHost.indexOf(constants.REBRANDED_NAME.toLowerCase()) > -1;
  return {
    currentOrigin: currentOrigin,
    currentHost: currentHost,
    rebrandState: rebrandState
  };
};
var getBrandBasedConfig = function getBrandBasedConfig(attribute) {
  var rebrandState = getCurrentApplicationHostInfo().rebrandState;
  if (typeof rebrandState !== 'undefined') {
    var _constants$brand$curr;
    var currentBrand = rebrandState ? 'scintilla' : 'luminate';
    return (_constants$brand$curr = constants.brand[currentBrand]) === null || _constants$brand$curr === void 0 ? void 0 : _constants$brand$curr[attribute];
  } else return '';
};
var helpers = {
  getCurrentApplicationHostInfo: getCurrentApplicationHostInfo,
  getBrandBasedConfig: getBrandBasedConfig
};
var tooltipIsDocMode = function tooltipIsDocMode() {
  return !!document.getElementById('story--components-tooltip--basic-usage--primary');
};

export { helpers as default, tooltipIsDocMode };
